import type { ReservationAlertType } from '@features/home/hooks/use-dashboard-alerts-state/useDashboardAlertsState.mfe.types';

export const ALERT_LABEL_MAP: Record<ReservationAlertType, string> = {
  MissingEtcas: 'Missing eTCA in upcoming reservations',
  NewRecords: 'New records published in the last 14 days',
};

export const ALERT_VARIANT_MAP: Record<
  ReservationAlertType,
  'danger' | 'info'
> = {
  MissingEtcas: 'danger',
  NewRecords: 'info',
};
